import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ListItem, Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useMemo } from 'react'
import type { To } from 'react-router'
import { useNavigate } from 'react-router'

import { COLORS, ICONS, unit } from '@hcr/ui'
import { isNotUndefined } from '@hcr/utils'

import { useLastPath } from '../../../../../contexts'
import { Path } from '../../../../../models'
import { isServicesPath, to } from '../../../../../utils'
import { BookingListDescription } from '../../../../booking/booking/common'
import type { BookingListPreviewProps } from '../../../../common'

export const BookingListPreview: FC<BookingListPreviewProps> = ({
  dateRange,
  destinationId,
  destinationName,
  isActive,
  onClick,
  totalTickets,
}) => {
  const lastPath = useLastPath()
  const navigate = useNavigate()

  const backNavigationPath = useMemo((): To => {
    if (isNotUndefined(destinationId) && isServicesPath(lastPath.root)) {
      return to([Path.Services, { destinationId }])
    }

    return lastPath.root
  }, [destinationId, lastPath.root])

  return (
    <ListItem disablePadding>
      <BookingListLink
        sx={{
          backgroundColor: isActive ? COLORS.hiekka[500] : COLORS.vaalea['60%'],
          color: isActive ? COLORS.white : COLORS.black,
          borderLeft: isActive ? `${unit(1)} solid ${COLORS.burgundi[500]}` : 'none',
        }}
        onClick={() => {
          onClick()
          void navigate(backNavigationPath)
        }}
      >
        <Stack width='100%'>
          <Stack direction='row' alignItems='center' justifyContent='space-between'>
            <Typography component='h2' color={isActive ? COLORS.burgundi[500] : 'inherit'} variant='displayS'>
              {destinationName}
            </Typography>
            <FontAwesomeIcon color={COLORS.black} icon={ICONS.fasChevronRight} fontSize={unit(5)} />
          </Stack>
          <BookingListDescription dateRange={dateRange} totalTickets={totalTickets} isActive={isActive} />
        </Stack>
      </BookingListLink>
    </ListItem>
  )
}

const BookingListLink = styled(Button)`
  display: flex;
  justify-content: space-between;
  gap: ${unit(4)};
  text-align: left;
  border-top: thin solid ${COLORS.vaalea[600]};
  padding: ${unit(4)} ${unit(8)} ${unit(5)} ${unit(7)};
  cursor: pointer;
`
